import classNames from 'classnames'
import { ReactNode } from 'react'

import { COMMON_ICONS_TYPE, commonIcons } from '@apps-common/config/icons'

export const NavbarIconSkeleton = () => (
  <div>
    <div className='relative'>
      <div>
        <div className='!flex items-center justify-center w-[40px] h-[40px] rounded-full bg-primary-content/5 backdrop-blur-md hover:opacity-70 animate-pulse' />
      </div>
    </div>
  </div>
)

interface ItemProps {
  icon: COMMON_ICONS_TYPE
  disabled?: boolean
  callback: () => void
  children?: ReactNode
  iconClasses?: string
}

export const NavbarIcon = ({ icon, disabled, callback, children, iconClasses }: ItemProps) => {
  const Icon = commonIcons[icon]

  return (
    <div className='md:relative'>
      <button
        type='button'
        aria-label='Navbar action'
        disabled={disabled}
        className={classNames(disabled && 'opacity-40')}
        onClick={() => {
          if (callback && !disabled) {
            callback()
          }
        }}
      >
        <div className='!flex items-center justify-center w-[40px] h-[40px] rounded-full bg-primary-content/5 backdrop-blur-md hover:opacity-70'>
          <Icon className={classNames('text-xl text-primary-content', iconClasses)} />
        </div>
      </button>
      {children}
    </div>
  )
}
